// Cell Renderer Registry
// Maps CellType → React render function
// Q-187: Screen Administrator

import type { ReactNode } from 'react';
import type { CellType } from '@/types/screen-definition';
import { TextCell } from './TextCell';
import { IdCell } from './IdCell';
import { BadgeCell } from './BadgeCell';
import { StatusCell } from './StatusCell';
import { PriorityCell } from './PriorityCell';
import { DateCell } from './DateCell';
import { AvatarCell } from './AvatarCell';

export interface CellRendererProps {
  value: unknown;
  row: Record<string, unknown>;
  config?: Record<string, unknown>;
}

type CellRenderer = (props: CellRendererProps) => ReactNode;

const cellRenderers: Record<Exclude<CellType, 'custom'>, CellRenderer> = {
  text: TextCell,
  id: IdCell,
  badge: BadgeCell,
  status: StatusCell,
  priority: PriorityCell,
  date: DateCell,
  avatar: AvatarCell,
};

export function getCellRenderer(type: CellType): CellRenderer | null {
  if (type === 'custom') return null;
  const renderer = cellRenderers[type] ?? null;
  if (!renderer && import.meta.env.DEV) {
    console.warn(
      `[getCellRenderer] No renderer for cell type "${type}". ` +
      `Add it to cellRenderers in cell-renderers/index.tsx.`
    );
  }
  return renderer;
}

export { TextCell, IdCell, BadgeCell, StatusCell, PriorityCell, DateCell, AvatarCell };
